<template>
    <div class='application' >
        <myBanner :imgSrc="imgSrc"/>
        <div class="showPc">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/index' }">{{title}}</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/index' }" v-show="!linkId &&flagSearch== -1">{{countryName}}</el-breadcrumb-item>
                <el-breadcrumb-item v-show="!titleQuery" :to="schoolListLink">院校列表</el-breadcrumb-item>
                <el-breadcrumb-item v-show="titleQuery" :to="{ path: '/linkDetail?id=' + linkId + '&title=' + titleQuery  + '&current=' + current }">{{titleQuery}}</el-breadcrumb-item>
                <el-breadcrumb-item v-show="!titleQuery" :to="schoolDetailLink">院校详情</el-breadcrumb-item>
                <el-breadcrumb-item v-show="titleQuery" :to="linkDetailLink">院校详情</el-breadcrumb-item>
                <el-breadcrumb-item>报名申请</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="showMobile">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/index' }"><span @click="goIndex">{{title}}</span></el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/index' }" v-show="flagSearch== -1"><span @click="goIndex2">详情</span></el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/index' }" v-show="!linkId &&flagSearch== -1"><span @click="goIndex2">{{countryName}}</span></el-breadcrumb-item>
                <el-breadcrumb-item v-show="!titleQuery" :to="schoolListLink">院校列表</el-breadcrumb-item>
                <el-breadcrumb-item v-show="titleQuery" :to="{ path: '/linkDetail?id=' + linkId + '&title=' + titleQuery  + '&current=' + current }">{{titleQuery}}</el-breadcrumb-item>
                <el-breadcrumb-item v-show="!titleQuery" :to="schoolDetailLink">院校详情</el-breadcrumb-item>
                <el-breadcrumb-item v-show="titleQuery" :to="linkDetailLink">院校详情</el-breadcrumb-item>
                <el-breadcrumb-item>报名申请</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="dashed"></div>
        </div>
        <div class="appliContent">
            <div class="appInfo">
                <img src="~assets/img/book.png" alt="">
                <div>
                    填写申请信息：
                    <span>* </span>
                    <span class="showMobile">为必填项，请同学认真填写。</span>
                    <span class="showPc">为必填项，请同学认真填写。招办确认后将提供免费参观园活动</span>
                </div>
            </div>
            <div class="appForm">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="80px" class="demo-ruleForm" label-position="left">
                    <el-row :gutter="50">
                        <el-col :md="12" :sm="24">
                            <el-form-item label="意向国家" prop="country">
                                <el-select v-model="ruleForm.country" placeholder="请选择意向国家" @change="demo($event)">
                                    <el-option :label="item.name" :value="item.value" v-for="(item,index) in countryList" :key="index"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :md="12" :sm="24">
                            <el-form-item label="意向院校" prop="schoolName">
                                <el-select v-model="ruleForm.schoolName" placeholder="请选择意向院校" @change="schoolId($event)">
                                    <el-option :label="item3.schoolName" :value="item3.id" v-for="(item3,index3) in schoolList" :key="index3"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="50">
                        <el-col :md="12" :sm="24">
                            <el-form-item label="留学层次" prop="grade">
                                <el-select v-model="ruleForm.grade" placeholder="请选择留学层次">
                                    <el-option :label="item2.levelName" :value="item2.id" v-for="(item2,index2) in schoolLevels" :key="index2"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :md="12" :sm="24">
                            <el-form-item label="学生姓名" prop="studentName">
                                <el-input placeholder="请输入姓名，与身份证一致" v-model="ruleForm.studentName"></el-input>
                            </el-form-item>
                        </el-col>
                       
                    </el-row>
                    <el-row :gutter="50">
                        <el-col :md="12" :sm="24">
                            <el-form-item label="身份证号" prop="idCard">
                                <el-input placeholder="请输入身份证号" v-model="ruleForm.idCard"></el-input>
                            </el-form-item>
                        </el-col>
                         <el-col :md="12" :sm="24">
                            <el-form-item label="学生性别" prop="sex">
                                <el-radio-group v-model="ruleForm.sex">
                                    <el-radio :label="1">男</el-radio>
                                    <el-radio :label="2">女</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="50">
                        <el-col :md="12" :sm="24">
                            <el-form-item label="出生年月" prop="birthday">
                                <el-date-picker
                                    v-model="ruleForm.birthday"
                                    value-format="yyyy-MM-ddTHH:mm:ss.000Z"
                                    type="date"
                                    placeholder="请选择日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :md="12" :sm="24">
                            <el-form-item label="手机" prop="tel">
                                <el-input placeholder="请输入手机号" v-model="ruleForm.tel"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="50">
                       <el-col :md="12" :sm="24">
                            <el-form-item label="电话" prop="phoneNumber">
                                 <el-input placeholder="请输入电话，加区号" v-model.number="ruleForm.phoneNumber"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :md="12" :sm="24">
                            <el-form-item label="QQ号码" prop="qq">
                                 <el-input placeholder="请输入QQ" v-model.number="ruleForm.qq"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item label="留言板" prop="desc">
                        <el-input type="textarea" placeholder="请输入留言" v-model="ruleForm.desc" maxlength="500" show-word-limit></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="appIntroduce">
                <span>* </span>
                <span>为必填项，请正确填写，如有任何疑问请拨打24小时全国咨询热线：400-838-5525，专业咨询老师指导你择校报名！</span>
            </div>
            <div class="appInfo">
                <img src="~assets/img/book.png" alt="">
                <div>申请资料</div>
            </div>
            <!-- 文件上传表格 -->
            <div class="applyForm showPc"
                v-loading="loading"
                element-loading-text="上传文件中">
                <el-table
                :data="tableData"
                border
                style="width: 100%">
                    <el-table-column
                        prop="conditionName"
                        label="申请文件"
                        align="center">
                    </el-table-column>
                    <el-table-column
                        label="操作"
                        align="center"
                        width="400px">
                        <template slot-scope="scope">
                            <input class="fileInput" type="file" :id="'fileExport' + scope.row.id" @change="handleFileChange(scope.row.id)" ref="inputer">
                            <div class="fileDetail">
                                <span>{{scope.row.fileInfo ? scope.row.fileInfo.originalFilename : '上传文件'}}</span>
                                <span v-show="scope.row.fileInfo">
                                    <!-- <a :href="url + (scope.row.fileInfo ? scope.row.fileInfo.src : '')">查看</a> -->
                                    <span @click="lookFile(scope.row)" style="position: relative;z-index: 100;">查看</span>
                                </span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="备注"
                        align="center">
                        <template slot-scope="scope">
                            <div v-show="scope.row.remark" class="fileDetail" @click="remarkDialog(scope.row.remark)">查看详情</div>
                            <div v-show="!scope.row.remark">暂无备注</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-- 移动文件上传 -->
            <div class="applyMobile showMobile">
                <div class="applyItem" v-for="(item4,index4) in tableData" :key="index4">
                    <div class="fileName">{{item4.conditionName}}</div>
                    <div class="fileArea">
                        <!-- <div class="tip" v-show="item4.remark">{{item4.remark}}</div> -->
                        <div class="tip" v-show="item4.remark" @click="remarkDialog(item4.remark)">查看备注</div>
                        <div v-show="item4.fileInfo" class="fileInfo">
                            {{item4.fileInfo ? item4.fileInfo.originalFilename : ''}}
                            <span @click="lookFile(item4)">查看</span>
                        </div>
                        <div class="addInput">
                            <input class="fileInput2" type="file" :id="'mFileExport' + item4.id" @change="handleFileChange(item4.id)">
                            <img src="~assets/img/addFile.png" alt="">
                        </div>
                    </div>
                </div>
                <div v-show="isShowFile" class="noData">暂无资料需上传</div>
            </div>
            
            <MyButton butTxt="提交信息" class="submit" @btnClick="submitForm('ruleForm')" />
            <el-dialog
                :visible.sync="dialogVisible"
                :width="dialogWidth"
                center
                :show-close="false">
                <span>是否确定提交</span>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" size="medium" @click="sureSubmit">确 定</el-button>
                    <el-button size="medium" @click="dialogVisible = false">取 消</el-button>
                </span>
            </el-dialog>
            <el-dialog
                :visible.sync="dialogRemark"
                :width="dialogWidthRemark">
                <div class="remarkTxt">{{remarkTxt}}</div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import { getDataMixin } from "common/mixin.js"
    import { upLoad , getCountryList, getSchoolList, getApplylList, order, checkRealName, orderList} from "network/application.js"
    import {isCellPhone, isCard} from "common/libs.js"

    export default {
        name:"schoolDetail",
        mixins:[getDataMixin],
        data(){
            var checkphone = (rule, value, callback) => {
                if (value == "") {
                    callback(new Error("请输入手机号"));
                } else if (!isCellPhone(value)) {
                    callback(new Error("请输入正确的手机号!"));
                } else {
                    callback();
                }
            };
            var checkIdCard = (rule, value, callback) => {
                if (value == "") {
                    callback(new Error("请输入身份证号"));
                } else if (!isCard(value)) {
                    callback(new Error("请输入正确的身份证号!"));
                } else {
                    callback();
                }
            };
            var checkNumber = (rule, value, callback) => {
                if (value != "") {
                    if((/^[0-9]*$/).test(value) == false){
                        callback(new Error("请输入正确格式"));
                    }else{
                        callback();
                    }
                }else{
                    callback();
                }
            };
            return {
                imgSrc:[],
                title:'',
                url:process.env.VUE_APP_WEB_URL,
                ruleForm: {
                    country:'',
                    grade:'',
                    schoolName:"",
                    studentName:"",
                    sex:1,
                    birthday:"",
                    tel:'',
                    phoneNumber:'',
                    idCard:'',
                    qq:'',
                    desc: ''
                },
                rules: {
                    country: [
                        { required: true, message: '请选择意向国家', trigger: 'change' }
                    ],
                    grade: [
                        { required: true, message: '请选择留学层次', trigger: 'change' }
                    ],
                    schoolName: [
                        { required: true, message: '请选择意向院校', trigger: 'change' }
                    ],
                    studentName: [
                        { required: true, message: '请输入姓名', trigger: 'blur' }
                    ],
                    sex: [
                        { required: true, message: '请选择性别', trigger: 'change' }
                    ],
                    birthday: [
                        { required: true, message: '请输入出生年月', trigger: 'blur' }
                    ],
                    tel: [
                        { required: true, validator: checkphone, trigger: 'blur' }
                    ],
                    idCard: [
                        { required: true, validator: checkIdCard, trigger: 'blur' }
                    ],
                    // tel: [
                    //     { required: true, message: '请输入手机号', trigger: 'blur' }
                    // ],
                    // idCard: [
                    //     { required: true, message: '请输入身份证号', trigger: 'blur' }
                    // ],
                    phoneNumber: [
                        // { required: true, message: '请输入电话', trigger: 'blur' },
                        // { type: 'number', message: '请输入正确电话'}
                        { required: false, validator: checkNumber, trigger: 'blur' }
                    ],
                    qq:[
                        { required: false, validator: checkNumber, trigger: 'blur' }
                    ]
                },
                tableData: [],
                countryList:[],
                schoolList:[],
                dialogVisible:false,
                dialogWidth:'20%',
                dialogWidthRemark:'40%',
                loading:false,
                isShowFile:false,
                dialogRemark:false,
                remarkTxt:'',
                levId: [],
                schoolLevels:[]
            }
        },
        created(){
            // 判断是否填写真实信息
            this.getCheckRealName()
            // 默认选中
            this.ruleForm.country = Number(this.getCountryId)
            this.ruleForm.schoolName = Number(this.id)
            
            if(this.$IsMobile()){
                this.dialogWidth = '80%'
                this.dialogWidthRemark = '80%'
            }

            this.getData();
            this.getCountryListData()
            this.getApplylListData(this.ruleForm.schoolName)
        },
        methods:{
            // ---- 接口请求 ---
            //意向国家
            getCountryListData(){
                getCountryList().then(res =>{
                    this.countryList = res.data
                })
            },
            // 院校列表
            getSchoolListData(data,callback){
                getSchoolList(data).then(res=>{
                    this.schoolList = res.data
                    callback ? callback() : ''
                    for(let i in res.data){
                        if(res.data[i].id == data.id){
                            this.schoolLevels = res.data[i].levelList
                            this.ruleForm.grade = this.schoolLevels[0].id
                            break
                        }
                    }
                })
            },
            // 订单列表
            getOrderList(){
                orderList({
                    current:1,
                    pageSize:100,
                    wxUserId:this.wxUserId
                }).then(res=>{
                    if(res.code == 1){
                        const id = res.data.records[0].id
                        this.$router.push('/orderDetail?id=' + id)
                    }
                })
            },
            // 获取countryId
            demo(value){
                this.ruleForm.country = value
                this.getSchoolListData({
                    countryId:value,
                    level:this.levId,
                    id:this.id
                },()=>{
                    this.ruleForm.schoolName = this.schoolList[0].id
                    this.schoolLevels = this.schoolList[0].levelList
                    this.ruleForm.grade = this.schoolLevels[0].id
                })
            },
            schoolId(id){
                this.getApplylListData(id)
                this.getSchoolListData({
                    countryId:this.ruleForm.country,
                    level:this.levId,
                    id:id
                })
            },  
            // 申请条件
            getApplylListData(id){
                getApplylList(id).then(res=>{
                    this.tableData = res.data
                    if(res.data == null){
                        this.isShowFile = true
                    }else{
                        this.isShowFile = false
                    }
                })
            },
            // 查真实姓名及手机号是否填写
            getCheckRealName(){
                checkRealName().then(res=>{
                    if(res.code == 2){
                        this.$router.push('/profile')
                        this.$message({
                            type:"warning",
                            message:"请先提交以下信息后进行报名",
                            duration:'5000'
                        })
                    }
                })
            },
            // ----  事件  -----
            getData(){
                this.navData = this.getNvData[this.getNavIndex - 1]
                if(this.navData){   
                    let bannerData = this.navData.themeBanners
                    if(bannerData.length && bannerData.length == 2){
                        for(let i in bannerData){
                            bannerData.push(bannerData[i])
                        }
                        this.imgSrc = bannerData
                    }else if(bannerData.length){
                        this.imgSrc = bannerData
                    }
                    this.title = this.navData.title
                  
                    if(this.getLevels && this.flagSearch == -1){
                        for(let i in this.getLevels){
                            this.levId.push(this.getLevels[i].id)
                        }
                    }
                    this.getSchoolListData({
                        countryId:this.ruleForm.country,
                        level:this.levId,
                        id:this.id
                    })
                }
            },
            goIndex(){
                this.$store.state.mShowControlMeue = true
            },
            goIndex2(){
                this.$store.state.mShowControlMeue = false
            },
            // 文件上传
            handleFileChange (id) {
                let file = ""
                if(this.$IsMobile()){
                    let inputDOM = document.getElementById('mFileExport' + id)
                    file = inputDOM.files[0]
                }else{
                    let inputDOM = document.getElementById('fileExport' + id)
                    file = inputDOM.files[0]
                }
                if(file){
                    this.loading = true
                    let formData = new FormData();//new一个formData事件
                    formData.append("file",file); //将file属性添加到formData里
                    upLoad(formData).then(res=>{
                        if(res.code == 1){
                            for(let i in this.tableData){
                                if(id == this.tableData[i].id){
                                    this.tableData[i].fileInfo = res.data
                                    // 及时修改数据
                                    this.$set(this.tableData,i,this.tableData[i])
                                }
                            }  
                        }else{
                            this.$message({
                                type:'error',
                                message:"上传失败"
                            })
                        }
                        this.loading = false
                    })
                }
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.dialogVisible = true
                    } else {
                        this.$message({
                            type:"error",
                            message:"请将信息填写完整"
                        })
                        return false;
                    }
                });
            },
            sureSubmit(){
                let fileList = []
                for(let i in this.tableData){
                    fileList.push({
                        conditionName: this.tableData[i].conditionName,
                        fileUrl:this.tableData[i].fileInfo ? this.tableData[i].fileInfo.src : ''
                    })
                }
                let data = {
                    applyCountryId : this.ruleForm.country,
                    applySchoolId : this.ruleForm.schoolName,
                    level : this.ruleForm.grade,
                    studentName : this.ruleForm.studentName,
                    sex : this.ruleForm.sex,
                    birthday : this.ruleForm.birthday,
                    mobile : this.ruleForm.tel,
                    telephone : this.ruleForm.phoneNumber,
                    idCard : this.ruleForm.idCard,
                    qq : this.ruleForm.qq,
                    message : this.ruleForm.desc,
                    wxUserApplyFileList : fileList
                }
                order(data).then(res =>{
                    if(res.code == 1){
                        this.getOrderList()
                        this.$message({
                            type:"success",
                            message:res.msg
                        })
                    }else{
                        this.$message({
                            type:"error",
                            message:res.msg
                        })
                    }
                    this.dialogVisible = false
                })
            },
            // 查看文件
            lookFile(scope){
                let fileUrl = this.url + scope.fileInfo.src
                const imgReg = /\.(png|jpe?g|gif|svg)(\?.*)?$/
                const flag = imgReg.test(fileUrl)
                if(flag){
                    window.open(fileUrl)
                }else{
                    window.location.href = fileUrl
                }
            },
            // 查看备注
            remarkDialog(txt){
                this.dialogRemark = true
                this.remarkTxt = txt
            }
        },
        computed:{
            id(){
               return this.$route.query.id ? this.$route.query.id : "" 
            },
            isRealName(){
                return this.$store.state.isRealName
            },
            current(){
                return this.$route.query.current ? this.$route.query.current : 1 
            },
            titleQuery(){
                return this.$route.query.title ? this.$route.query.title : '' 
            },
            linkId(){
                return this.$route.query.linkId ? this.$route.query.linkId : '' 
            },
            countryName(){
                return sessionStorage.getItem('countryName') ? sessionStorage.getItem('countryName') : '暂无'
            },
            getCountryId(){
                return this.$route.query.countryId ? this.$route.query.countryId : ''
            },
            schoolDetailLink(){
                return localStorage.getItem('schoolDetailLink') ? localStorage.getItem('schoolDetailLink') : ''
            },
            schoolListLink(){
                return localStorage.getItem('schoolListLink') ? JSON.parse(localStorage.getItem('schoolListLink')) : ''
            },
            flagSearch(){
                return this.schoolListLink.path.indexOf('search')
            },
            linkDetailLink(){
                return localStorage.getItem('linkDetailLink') ? localStorage.getItem('linkDetailLink') : ''
            },
            getLevels(){
                return localStorage.getItem('levels') ? JSON.parse(localStorage.getItem('levels')) : []
            },
            wxUserId(){
                return localStorage.getItem('wxUserId') ? localStorage.getItem('wxUserId') : ''
            }
        }
    }
</script>
<style scoped lang="scss">
.appliContent{
    .el-select,.el-date-editor.el-input{
        width:100%;
    }
    .el-dialog--center .el-dialog__body{
        font-size: 16px;
        text-align: center!important;
    }
    .remarkTxt{
        text-indent:28px;
        line-height: 20px;
    }
    .appInfo{
        background:var(--color-bg-main) ;
        display: flex;
        align-items: center;
        padding:10px 20px;
        margin:30px 0 20px;
        font-size:14px;
        img{
            width: 20px;
            margin-right:10px;
        }
        div{
            span:nth-child(1){
                color:#F56C6C;
            }
        }
    }
    .appIntroduce{
        font-size:14px;
        span:nth-child(1){
            color:#F56C6C;
        }
        span:nth-child(2){
            color:var(--color-main);
        }
    }
    .applyForm{
        .fileDetail{
            color:var(--color-main);
            cursor: pointer;
            span:nth-child(1){
                margin-right:10px;
                
            }
            a{
                color: var(--color-main);
            }
        }
        .fileInput{
            background: red;
            width:55px;
            position: absolute;
            top:12px;
            left:150px;
            opacity: 0;
        }
    }
    .submit{
        margin: 40px auto;
    }
}
@media screen and (max-width: 768px){
    .appliContent{
        width: 90%;
        margin:0 auto;
        .appInfo{
            padding:0.2rem 0.3rem;
            margin:0.3rem 0 0.3rem;
            font-size:0.26rem;
            img{
                width: 0.3rem;
                margin-right:0.1rem;
            }
            div .showMobile{
                display: inline-block;
            }
        }
         .submit{
            margin: 0.4rem auto;
        }
        // 文件上传
        .applyMobile{
            font-size:0.3rem;
            .fileArea{
                border:1px solid var(--color-border);
                border-radius: 3px;
                padding:0.15rem;
                margin:0.15rem 0 0.3rem 0;
                color:#727375;
                font-size:0.28rem;
                .tip{
                    margin-bottom:0.15rem;
                    color:var(--color-main);
                }
                .fileInfo{
                    color:var(--color-main);
                    margin-bottom:0.15rem;
                }
                .addInput{
                    position: relative;
                    .fileInput2{
                        width:0.7rem;
                        height:0.7rem;
                        position: absolute;
                        top:0px;
                        left:0px;
                        opacity: 0;
                    }
                    img{
                        width:0.7rem;
                    }
                }
                
            }
            .noData{
                text-align: center;
            }
        }
    }
}
</style>